<template>
  <div v-if="show" class="modal-overlay">
    <div class="confirm-modal">
      <button class="close-button" @click="handleClose">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16504 4.16602L15.8309 15.8319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4.1642 15.8319L15.8301 4.16602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div class="modal-content">
        <div class="modal-content-inner">
          <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
            <path d="M24.9434 51.313L17.9292 55.3601C21.9764 60.1566 27.5725 63.3881 33.7499 64.4959V56.3987C30.4065 55.5343 27.3619 53.775 24.9434 51.3099V51.313ZM56.8127 32.9147L63.8205 28.8677C65.9494 34.7701 65.9494 41.2307 63.8205 47.133L56.8127 43.0892C57.7309 39.7586 57.7297 36.2416 56.8095 32.9115L56.8127 32.9147ZM59.0705 20.6407L52.0532 24.6877C49.6352 22.2243 46.5918 20.4661 43.2499 19.602V11.5049C49.4272 12.6127 55.0233 15.8442 59.0705 20.6407ZM43.2499 64.4959C49.4272 63.3881 55.0233 60.1566 59.0705 55.3601L52.0564 51.313C49.6375 53.777 46.5929 55.5352 43.2499 56.3987V64.4959Z" stroke="#7AC4EB" stroke-width="2" stroke-linejoin="round" />
            <path d="M16.6658 45.0941C15.1681 40.4838 15.1681 35.5177 16.6658 30.9074M21.4379 22.6392C24.6819 19.0369 28.9829 16.5539 33.7246 15.5459" stroke="#7AC4EB" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
        <h2 class="modal-title">Delete Confirmation</h2>
        <p class="modal-message">{{ message }}</p>

        <div class="modal-buttons">
          <button class="cancel-button" @click="handleClose">Cancel</button>
          <button class="confirm-button" @click="handleConfirm">Yes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConfirmationModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: false,
      default: 'Are you sure you want to delete this job?',
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.confirm-modal {
  display: flex;
  width: 405px;
  height: 352px;
  padding: 24px 24px 23px 40px;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  position: relative;
}

.close-button {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 14px;
  top: 14px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.modal-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.modal-title {
  color: var(--primary-color);
  text-align: left;
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 2px;
  margin-top: 8px;
}

.modal-message {
  overflow: hidden;
  color: #667085;
  text-overflow: ellipsis;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  text-align: center;
  margin-bottom: 18px;
}

.modal-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.modal-buttons button {
  width: 123.915px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: Archivo;
  font-weight: 500;
}

.cancel-button {
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
}

.confirm-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.modal-content-inner {
  display: flex;
  width: 100px;
  height: 100px;
  padding: var(--Micro-XL, 12px);
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background-color: #f0f9fd;
  border-radius: 50%;
}
</style>
